module.exports = __webpack_public_path__ + "img/组 11@2x.375f5aac.png";